import { ArrowLeft } from 'lucide-react';
import { SeoHead } from './SeoHead';

export function LegalPage({ title, seoTitle, seoDesc, lastUpdated, children, activePage }) {
  const links = [
    { href: '/privacy', label: 'Privacy Policy' },
    { href: '/cookie',  label: 'Cookie Policy' },
    { href: '/terms',   label: 'Termini e Condizioni' },
  ];

  return (
    <div style={{ background: '#080808', color: '#e5e5e5', fontFamily: "'DM Sans', sans-serif", minHeight: '100vh' }}>
      <SeoHead page="legal" lang="it" theme="dark" />

      {/* Nav */}
      <div className="sticky top-0 z-40 border-b" style={{ background: 'rgba(8,8,8,0.96)', backdropFilter: 'blur(20px)', borderColor: '#1a1a1a' }}>
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <ArrowLeft size={15} style={{ color: 'rgba(229,229,229,0.5)' }} />
            <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '18px', fontWeight: 300, letterSpacing: '0.05em', color: '#e5e5e5' }}>
              Shangrilux
            </span>
          </a>
          <a href="/#demo" className="text-sm px-4 py-2 rounded-sm font-medium"
            style={{ background: '#c9a84c', color: '#000' }}>
            Demo Gratuita
          </a>
        </div>
      </div>

      {/* Sub-nav links */}
      <div className="border-b" style={{ borderColor: '#141414' }}>
        <div className="max-w-4xl mx-auto px-6 flex gap-6 overflow-x-auto">
          {links.map(l => (
            <a key={l.href} href={l.href}
              className="text-xs py-3 shrink-0 transition-colors"
              style={{
                color: activePage === l.href ? '#c9a84c' : 'rgba(229,229,229,0.4)',
                borderBottom: activePage === l.href ? '1px solid #c9a84c' : '1px solid transparent',
              }}>
              {l.label}
            </a>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16 pb-24">
        <div className="mb-12">
          <p className="text-xs tracking-[4px] uppercase mb-4" style={{ color: '#c9a84c' }}>Documentazione Legale</p>
          <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(32px,4vw,52px)', fontWeight: 300, lineHeight: 1.15, marginBottom: '12px', color: '#e5e5e5' }}>
            {title}
          </h1>
          <p className="text-sm" style={{ color: 'rgba(229,229,229,0.35)' }}>
            Ultimo aggiornamento: {lastUpdated} · Versione applicabile: Shangrilux SaaS Platform
          </p>
          <div className="mt-6 h-px w-16" style={{ background: '#c9a84c', opacity: 0.4 }} />
        </div>

        <div className="legal-content" style={{ lineHeight: 1.85, color: 'rgba(229,229,229,0.75)' }}>
          {children}
        </div>
      </div>

      {/* Footer */}
      <div className="border-t py-10" style={{ borderColor: '#1a1a1a' }}>
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '16px', fontWeight: 300, color: 'rgba(229,229,229,0.3)' }}>
            Shangrilux
          </span>
          <div className="flex gap-6">
            {links.map(l => (
              <a key={l.href} href={l.href} className="text-xs"
                style={{ color: activePage === l.href ? '#c9a84c' : 'rgba(229,229,229,0.3)' }}>
                {l.label}
              </a>
            ))}
          </div>
          <p className="text-xs" style={{ color: 'rgba(229,229,229,0.25)' }}>
            © {new Date().getFullYear()} Shangrilux — All rights reserved
          </p>
        </div>
      </div>

      {/* Typography helpers */}
      <style>{`
        .legal-content h2 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 22px;
          font-weight: 400;
          color: #e5e5e5;
          margin-top: 48px;
          margin-bottom: 16px;
          padding-bottom: 8px;
          border-bottom: 1px solid #1e1e1e;
        }
        .legal-content h3 {
          font-size: 15px;
          font-weight: 600;
          color: rgba(229,229,229,0.9);
          margin-top: 28px;
          margin-bottom: 10px;
        }
        .legal-content p { margin-bottom: 14px; font-size: 14px; }
        .legal-content ul { margin-left: 20px; margin-bottom: 14px; list-style: disc; }
        .legal-content li { margin-bottom: 6px; font-size: 14px; }
        .legal-content strong { color: rgba(229,229,229,0.9); font-weight: 600; }
        .legal-content a { color: #c9a84c; text-decoration: underline; }
        .legal-content .highlight-box {
          padding: 16px 20px;
          border-left: 2px solid #c9a84c;
          background: rgba(201,168,76,0.06);
          border-radius: 0 4px 4px 0;
          margin: 20px 0;
        }
        .legal-content table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
          margin: 20px 0;
        }
        .legal-content th {
          text-align: left;
          padding: 8px 12px;
          border-bottom: 1px solid #2a2a2a;
          color: rgba(229,229,229,0.5);
          font-weight: 500;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .legal-content td {
          padding: 10px 12px;
          border-bottom: 1px solid #141414;
          vertical-align: top;
        }
      `}</style>
    </div>
  );
}
